import styled from '@app/styled';
import { color, spacing, typography } from '@app/theme';

export const Container = styled.nav``;

export const NavigationTabList = styled.ul`
    display: flex;
    list-style: none;
    flex-wrap: wrap;
    margin: 0 0 0 -${spacing(6)}; // Multi-row alignment
    padding: 0;
`;

export const NavigationTab = styled.li`
    border: none;
    margin: 0;
    border-bottom: 2px solid transparent;
    background: none;
    appearance: none;

    ${typography('description')};
    margin: 0 0 0 ${spacing(6)};
    color: ${color('content.primary')};

    &[aria-selected='true'] {
        font-weight: 500;
        color: ${color('primary.500')};
        border-bottom-color: currentColor;
    }
`;
